<template>
  <div v-if="loaded" class="branding-special-field my-6">
    <div v-html="specialFieldContent" class="mb-5" />
    <b-button
      @click="generateDocument"
      type="is-blue"
      icon-right="file-download"
    >
      {{ $t("'mp:self_onboarding.button.generate_document") }}
    </b-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "DocGenerateSpecialField",
  components: {},
  props: {
    specialFieldContent: {
      type: String,
      required: false,
    },
    questionConfigId: {
      type: Number,
      required: true,
    },
    fieldId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      applicationVisiblePoll: null,
      isPurchaseListEmpty: true,
      fields: {
        compactLogo: null, // private MultipartFile
        bigLogo: null, // private MultipartFile
        brandingPrimary: "#000000", // private String
        brandingSecondary: "#000000", // private String
      },
      logos: {
        compactLogo: null,
        bigLogo: null,
      },
      formData: new FormData(),
    };
  },
  watch: {
    fields: {
      async handler(fields) {
        for (const [key, value] of Object.entries(fields)) {
          if (value) {
            this.formData.set(key, value);
          }
        }
      },
      deep: true,
    },
    formData: {
      handler(value) {
        console.log("formData: ", value);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      branding: "onboarding/branding",
    }),
  },
  methods: {
    ...mapActions({
      getMyBranding: "onboarding/getMyBranding",
      putBranding: "onboarding/putBranding",
      downloadFile: "onboarding/downloadFile",
      generateDocumentAction: "onboarding/generateDocument",
    }),
    async generateDocument() {
      // this.putBranding(this.formData);
      const documentId = await this.generateDocumentAction({
        fieldId: this.fieldId,
        configId: this.questionConfigId,
      });
      const file = await this.downloadFile(documentId);
      FileSaver.saveAs(file, `document_${documentId}`);
    },
    getLogoPreview(file) {
      if (file) {
        return URL.createObjectURL(file);
      }
    },
  },
  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
.field {
  margin-bottom: 3rem;
}

.file-upload {
  position: relative;
  box-sizing: content-box;
  width: 100%;
  height: 119px;

  .upload.control {
    padding: 0 !important;
    width: 100%;
    height: calc(100% - 24px);
  }

  .logo-preview {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .delete {
      position: absolute;
      top: 8px;
      right: 8px;
    }

    img {
      border-radius: inherit;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.branding-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 2rem;

  .field {
    margin-bottom: 0;
  }
}
</style>

<style lang="scss">
input[type="color"] {
  // border: 1px solid red;
  padding: 2px;
  width: 50px;
}
.branding-special-field {
  & > .field {
    margin-bottom: 2rem;
  }

  .label {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-bottom: 4px;

    .tooltip-trigger {
      height: 16px;
    }

    .b-tooltip {
      height: 16px;
    }
  }
}
</style>
